import { constants } from "../constants/redux-constants";

export const addTask = (task) => ({
  type: constants.BACKGROUND_TASKS.ADD_TASK,
  payload: task,
});

export const updateTask = (id, updates) => ({
  type: constants.BACKGROUND_TASKS.UPDATE_TASK,
  payload: { id, updates },
});

export const deleteTask = (id) => ({
  type: constants.BACKGROUND_TASKS.DELETE_TASK,
  payload: id,
});

export const clearTasks = () => ({
  type: constants.BACKGROUND_TASKS.CLEAR_TASKS,
});

export const markTaskAsRead = (taskId) => ({
  type: constants.BACKGROUND_TASKS.MARK_AS_READ,
  payload: taskId,
});

export const markFailedTasksAsRead = () => ({
  type: constants.BACKGROUND_TASKS.MARK_FAILED_AS_READ,
});

export const removeActiveTasks = () => ({
  type: constants.BACKGROUND_TASKS.REMOVE_ACTIVE_TASKS,
});

export const set_show_task_inprogress_popup = (payload) => ({
  type: constants.BACKGROUND_TASKS.SHOW_TASK_INPROGRESS_POPUP,
  payload: payload,
});